const angular = require('angular');

// IMPORTANT : don't use this directive on an ng-show! use ng-if instead

module.exports = function ($interval) {
    return {
        restrict: 'E',
        scope: {
            srMessage: '@',
            srDelay: '@',
            shouldAnnounce: '='
        },
        link(scope, element) {

            if (scope.shouldAnnounce !== false) {

                // A11y message
                const defaultMessage = 'Loading please wait';
                const defaultDelay = 5000;
                let interval;

                scope.srMessage = scope.srMessage ? scope.srMessage : defaultMessage;
                scope.srDelay = scope.srDelay ? parseInt(scope.srDelay) : defaultDelay;

                scope.message = scope.srMessage;

                scope.loadingMessageInterval = function () {
                    if (!interval) {
                        interval = $interval(function () {
                            scope.message = scope.message ? '' : scope.srMessage;
                        }, scope.srDelay / 2);
                    }
                };

                scope.loadingMessageInterval();

                element.on('$destroy', function () {
                    if (angular.isDefined(interval)) {
                        $interval.cancel(interval);
                        interval = undefined;
                    }
                });
            }

        },
        template: require('./spinner-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/loading-spinner/spinner-directive.js
 **/